export interface IConsentCookie {
  functional: boolean;
  mandatory: boolean;
  personal: boolean;
  AIRecommendations?: boolean;
  version: number;
}

export interface ICookieConsentTypesResolverPayload {
  resolve: (value: IConsentCookie | PromiseLike<IConsentCookie>) => void;
  reject: (reason?: unknown) => void;
}

export enum CustomerType {
  Company = "Company",
  Private = "Private",
  Surgery = "Surgery"
}
